import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "players-section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "player-list" }
const _hoisted_4 = { class: "player-info" }
const _hoisted_5 = {
  key: 0,
  class: "host-icon",
  title: "Администратор"
}
const _hoisted_6 = { class: "player-name" }

import type { PlayerPublic, Roles } from '@/types/game';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayerList',
  props: {
    players: {},
    roles: {}
  },
  setup(__props: any) {

const props = __props;

const totalRoles = computed(() => Object.values(props.roles).reduce((sum, count) => sum + count, 0));
const emptySlots = computed(() => Math.max(0, totalRoles.value - props.players.length));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, "Игроки: " + _toDisplayString(_ctx.players.length), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
        return (_openBlock(), _createElementBlock("div", {
          key: player.name,
          class: "player-slot"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (player.is_host)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "👑"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, _toDisplayString(player.name), 1)
          ])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emptySlots.value, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `empty-${i}`,
          class: "player-slot empty"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "player-name" }, "Ожидание игрока...", -1)
        ])))
      }), 128))
    ])
  ]))
}
}

})